/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './unassignModerator.defs.js'
export { main as default } from './unassignModerator.defs.js'
